<div
  style="display: none; position: absolute; top: 0; left: 0; width: 0; height: 0"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
></div>
<div
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayoutGap="0.25rem"
>
  <div
    class="opener pointer"
    (click)="isOpen = true"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <!-- <i class="efpicon efpicon-arrow-right"></i> -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
    >
      <title>arrow-right</title>
      <g fill="currentColor">
        <g
          id="arrow-wrap"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
        >
          <g
            id="arrow"
            transform="translate(-36 -96)"
            stroke="currentColor"
            stroke-width="3"
          >
            <g
              id="Group-Copy"
              transform="matrix(-1 0 0 1 52 97)"
            >
              <path
                id="Path-7"
                d="M1.19 5.241h13.441"
              ></path>
              <path
                id="Path-8"
                d="M5.1 0L0 5.241l5.1 4.976"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    style="padding-left: 2rem"
    class="pointer"
    (click)="routeToRoot()"
  >
    <svg
      width="25px"
      height="24px"
      viewBox="0 0 25 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>Parts Icon</title>
      <g
        id="Tech---Part-Search"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g
          id="eFP---ATS-Master-Parts---History"
          transform="translate(-54, -13)"
          stroke="#DB1D3A"
          stroke-width="1.5"
        >
          <g
            id="Parts-Icon"
            transform="translate(55.4254, 13.8557)"
          >
            <path
              d="M20.6877,5.28495 L18.67305,2.92215 L16.423275,4.53915 C15.616425,3.891525 14.713875,3.409725 13.763475,3.10035 L13.75275,0.24585 L10.6557,0 L10.209375,2.733225 C9.212775,2.84295 8.231025,3.13005 7.3128,3.597825 L5.284125,1.58565 L2.92215,3.60195 L4.538325,5.851725 C3.891525,6.658575 3.409725,7.5603 3.10035,8.5107 L0.245025,8.52225 L0,11.618475 L2.733225,12.0648 C2.8413,13.060575 3.13005,14.04315 3.597,14.9622 L1.586475,16.99005 L3.601125,19.35285 L5.851725,17.73585 C6.658575,18.383475 7.5603,18.865275 8.509875,19.17465 L8.521425,22.02915 L11.61765,22.275 L12.065625,19.541775 C13.060575,19.432875 14.0415,19.14495 14.9622,18.678 L16.99005,20.6877 L19.35285,18.67305 L17.73585,16.42245 C18.38265,15.616425 18.86445,14.7147 19.173825,13.7643 L22.02915,13.75275 L22.275,10.656525 L19.54095,10.209375 C19.432875,9.2136 19.14495,8.23185 18.677175,7.3128 L20.6877,5.28495 Z"
              id="Stroke-1"
            ></path>
            <path
              d="M14.0473575,8.6538375 C15.4201575,10.2625875 15.2287575,12.6773625 13.6208325,14.0485125 C12.0129075,15.4204875 9.5973075,15.2299125 8.2253325,13.6211625 C6.8541825,12.0132375 7.0455825,9.5984625 8.6535075,8.2256625 C10.2606075,6.8545125 12.6762075,7.0459125 14.0473575,8.6538375 Z"
              id="Stroke-3"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  @if (selectedModule) {
  <div
    class="masthead-label"
    style="padding-left: 0.25rem"
  >
    PME
  </div>
  }
  <div class="masthead-label">:</div>
  @if (currentContainer$ | async; as currentContainer) {
  <div class="masthead-label">
    {{ currentContainer.displayname | transloco }}
  </div>
  }
  <a
    id="linkAnchor"
    style="display: none"
    href="/"
    >.</a
  >
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  (overlayOutsideClick)="isOpen = false"
  #drawer
>
  <div class="drawer">
    <div
      class="closer pointer"
      (click)="isOpen = false"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <!-- <i class="efpicon efpicon-arrow-right efpicon-rotate-180"></i> -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="13"
        viewBox="0 0 18 13"
      >
        <title>arrow-right</title>
        <g fill="currentColor">
          <g
            id="arrow-wrap"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
          >
            <g
              id="arrow"
              transform="translate(-36 -96)"
              stroke="currentColor"
              stroke-width="3"
            >
              <g
                id="Group-Copy"
                transform="matrix(-1 0 0 1 52 97)"
              >
                <path
                  id="Path-7"
                  d="M1.19 5.241h13.441"
                ></path>
                <path
                  id="Path-8"
                  d="M5.1 0L0 5.241l5.1 4.976"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="logo-wrapper">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
      >
        <div class="logo efpicon efpicon-pme-logo"></div>
        <div class="logo-name">{{ selectedModule?.displayname | transloco }}</div>
      </div>
      <div class="build">{{ buildNumber }}</div>
    </div>
    <div class="scroll-wrapper">
      <div class="modules">
        <div class="drill-container">
          @if (selectedModule) {
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="0.25rem"
            class="module-row first active"
          >
            <div
              fxFlex="3rem"
              class="pointer"
              style="padding-left: 1.5rem"
            >
              <i
                class="efpicon"
                [ngClass]="selectedModule.icon"
              ></i>
            </div>
            <div>
              {{ selectedModule.displayname | transloco }}
            </div>
            <div fxFlex></div>
          </div>
          <div class="container-wrapper opened">
            @for (efpContainer of selectedModule.containers; track efpContainer; let last = $last) {
            @if (!efpContainer.hidden) {
            <div
              fxLayout="row"
              fxLayoutGap="0.25rem"
            >
              <div fxFlex="2.5rem"></div>
              <div
                class="container-row"
                [class.last]="last"
                [class.active]="currentContainer === selectedModule.module + '|' + efpContainer.container"
                (click)="routeToContainer(selectedModule.link, efpContainer.container)"
                fxLayout="column"
                fxLayoutAlign="center start"
                fxLayoutGap="0.2rem"
              >
                <div class="container">
                  {{ efpContainer.displayname | transloco }}
                </div>
                <div class="description">
                  {{ efpContainer.description | transloco }}
                </div>
              </div>
            </div>
            } }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
